export const VARIABLES = ['a', 'b', 'c', 'd', 'x', 'y', 'z']

export const RANGE_DATA: RangeDataModel = {
  1: {
    minTerms: 4,
    maxTerms: 10,
    minExponent: 1,
    maxExponent: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    minInteger: 1,
    maxInteger: 10,
    totalVariable: 1,
  },
  2: {
    minTerms: 4,
    maxTerms: 10,
    minExponent: 1,
    maxExponent: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    minInteger: 1,
    maxInteger: 10,
    totalVariable: 1,
  },
  3: {
    minTerms: 6,
    maxTerms: 13,
    minExponent: 1,
    maxExponent: 3,
    minCoefficient: 1,
    maxCoefficient: 8,
    minInteger: 1,
    maxInteger: 10,
    totalVariable: 1,
  },
  4: {
    minTerms: 8,
    maxTerms: 16,
    minExponent: 1,
    maxExponent: 5,
    minCoefficient: 1,
    maxCoefficient: 8,
    minInteger: 1,
    maxInteger: 10,
    totalVariable: 2,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minTerms: number
  maxTerms: number
  minExponent: number
  maxExponent: number
  minCoefficient: number
  maxCoefficient: number
  minInteger: number
  maxInteger: number
  totalVariable: number
}
